import { node } from "prop-types";

import styled from "styled-components";

import FnrTypography from "UI/FnrTypography";
import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";
import { use2FAState, useNetworkKnown } from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { welcomeMessageComponentKeys } from "Login/TwoFA/constants";
import { useActiveWelcomeMessageKey } from "Login/TwoFA/stateHooks";
import { AnimatePresence, motion } from "motion/react";

import FnrBannerLogo from "UI/FnrBannerLogo";
import FnrNetworkPhoto from "UI/FnrNetworkPhoto";
import FnrSlides from "UI/FnrSlides";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";
import { inOutZoom } from "UI/motionStyles";

const SFnrHorizontalGap = styled(FnrHorizontalGap)`
  padding-bottom: ${({ $noPadding }) => ($noPadding ? "0px" : `16px;`)};
  min-height: 82px;
  transition: padding-bottom 300ms;
`;

const Container = ({ children, ...rest }) => {
  const activeWelcomeMessageKey = useActiveWelcomeMessageKey();

  const noMessage =
    activeWelcomeMessageKey === welcomeMessageComponentKeys.withoutName;

  return (
    <SFnrHorizontalGap {...rest} $noPadding={noMessage}>
      {children}
    </SFnrHorizontalGap>
  );
};

Container.propTypes = { children: node };

const NetworkDisplayContents = () => {
  const [{ networkName, networkPhotoUrl }] = use2FAState();

  const hasPhoto = Boolean(networkPhotoUrl);
  const hasNetworkName = Boolean(networkName);

  return (
    <Container data-cy="TwoFA_NetworkDisplay">
      {hasPhoto && (
        <FnrNetworkPhoto
          src={networkPhotoUrl}
          shape="square"
          size="decorative2"
        />
      )}
      {hasNetworkName && (
        <FnrTypography type="header" fontSize="xl">
          {networkName}
        </FnrTypography>
      )}
    </Container>
  );
};

const FlockNoteLogo = () => (
  <Container data-cy="TwoFA_FlocknoteBannerLogo">
    <FnrBannerLogo />
  </Container>
);

const components = [
  { key: "flocknoteLogo", value: () => <FlockNoteLogo /> },
  { key: "networkLogo", value: () => <NetworkDisplayContents /> },
];

const NetworkDisplay = () => {
  const { showNetwork, variant } = useTwoFAContext();
  const { isFetched } = usePostTwoFactorAuth({ variant });
  const networkKnown = useNetworkKnown();

  const activeKey = networkKnown ? "networkLogo" : "flocknoteLogo";

  if (!isFetched) return null;
  return (
    <AnimatePresence initial={false}>
      {showNetwork && (
        <motion.div {...inOutZoom}>
          <FnrSlides activeKey={activeKey} fullWidth components={components} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NetworkDisplay;
